module.exports = __webpack_public_path__ + "static/media/sf-test-7.c0d35a7b.mp3";